import { Controller } from '@hotwired/stimulus'
import Sortable from 'sortablejs'

export default class SortableController extends Controller<HTMLElement> {
  declare sortable?: Sortable

  connect() {
    this.sortable = Sortable.create(this.element, this.#getOptions())
  }

  disconnect() {
    this.sortable?.destroy()
  }

  // Private methods

  #defaultOptions() {
    return {
      animation: 75,
      dragClass: 'cursor-move',
      filter: '.not-draggable',
      handle: '.sort-handle',
    } satisfies Sortable.SortableOptions
  }

  #dispatchEvent<EventType = Sortable.SortableEvent>(eventName: string, event: EventType) {
    this.dispatch(eventName, { detail: { ...event } })
  }

  #eventOptions() {
    return {
      onAdd: event => this.#dispatchEvent('add', event),
      onChange: event => this.#dispatchEvent('change', event),
      onChoose: event => this.#dispatchEvent('choose', event),
      onClone: event => this.#dispatchEvent('clone', event),
      onEnd: event => this.#dispatchEvent('end', event),
      onFilter: event => this.#dispatchEvent('filter', event),
      onMove: (event, originalEvent) => this.#dispatchEvent('move', { ...event, originalEvent }),
      onRemove: event => this.#dispatchEvent('remove', event),
      onSort: event => this.#dispatchEvent('sort', event),
      onStart: event => this.#dispatchEvent('start', event),
      onUnchoose: event => this.#dispatchEvent('unchoose', event),
      onUpdate: event => this.#dispatchEvent('update', event),
    } satisfies Sortable.SortableOptions
  }

  #getOptions() {
    const options: Sortable.SortableOptions = JSON.parse(this.element.dataset.sortableOptions || '{}')

    return {
      ...this.#defaultOptions(),
      ...options,
      ...this.#eventOptions(),
    } satisfies Sortable.SortableOptions
  }
}
